<div class="bulk-upload-result-container col full-height">
  <div class="header flex">
    <div class="close-button flex va-c ha-c">
      <button mat-icon-button (click)="close()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    <span class="title">{{heading}}</span>
  </div>
  <div class="bulk-upload-result-content col">
    <div *ngIf="!fileIsReadyToDownload && data.message" class="row-1 full-width">
      <div class="result-line">Successfully Uploaded Organizations: {{data.organizations}}</div>
      <div class="result-line">Successfully Uploaded Divisions: {{data.divisions}}</div>
      <div class="result-line">Successfully Uploaded Human Resources: {{data.humanResources}}</div>
      <div class="result-line">Successfully Uploaded Vehicles: {{data.vehicles}}</div>
      <div class="result-line">Successfully Uploaded Locations: {{data.locations}}</div>
    </div>
    <div *ngIf="fileIsReadyToDownload" class="row-1 full-width">
      <div class="error-validation">Issues were found in the uploaded file. Please download the file and fix the errors
        marked in red by referring to the error notes added to the cells.</div>
    </div>
    <div class="row-2">
      <div *ngIf="!fileIsReadyToDownload && data.message">
        <div class="message">{{data.message}}</div>
      </div>
      <div *ngIf="data.errorResponse && !fileIsReadyToDownload">
        <div class="error-message">Internal Server Error!</div>
      </div>
    </div>
  </div>
  <div class="fill-space"></div>
  <div class="footer flex ai-c">
    <!-- <button *ngIf="fileIsReadyToDownload" mat-button class="download ml-10" (click)="download()">
      DOWNLOAD FILE
    </button> -->
    <button mat-button class="cancel ml-10" (click)="close()">
      OK
    </button>
  </div>
</div>